<template>
  <v-tab-item v-if="getPermission('gifts.read')" :value="$route.path" class="pa-3">
    <v-toolbar flat height="90">
      <div class="d-flex flex-column pt-6">
        <v-col>
          <ExportLinks export-key="company-all-vouchers" :filters="{ q: search || '' }" />
        </v-col>
      </div>
      <v-spacer></v-spacer>

      <v-col cols="4">
        <b-search-field v-model="search"></b-search-field>
      </v-col>
    </v-toolbar>
    <b-data-table
      :headers="headers"
      :items="allGifts"
      :page.sync="page"
      @page-sync="(p) => (page = p)"
    >
      <template v-slot:no-data>
        {{ translations.noData[lang] }}
      </template>
      <template v-slot:item.redemption_date="{ item }">
        {{ formatDate(item.redemption_date) }}
      </template>
      <template v-if="isSuperAdmin" v-slot:item.actions="{ item }">
        <v-btn
          color="grey lighten-2"
          class="text-capitalize my-1 red--text"
          depressed
          @click="openCancelVoucherDialog(item)"
          >{{ translations.cancel[lang] }}</v-btn
        >
      </template>
      <template v-slot:item.coupon_claim_is_expired="{ item }">
        <v-icon v-if="item.coupon_claim_is_expired" color="green">mdi-check-circle-outline</v-icon>
        <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
      </template>
    </b-data-table>
    <v-dialog v-model="cancelDialog" max-width="500">
      <CancelVoucherDialog @cancel="cancelDialog = false" />
    </v-dialog>
  </v-tab-item>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import translations from '@/utils/translations/loyaltyPanel/redemptions';
import CancelVoucherDialog from '@/components/loyaltyPanel/giftCatalog/CancelVoucherDialog.vue';
import debounce from 'lodash/debounce';
import moment from 'moment';
import ExportLinks from '@/components/general/ExportLinks.vue';

export default {
  name: 'All',

  mixins: [translations],

  components: {
    CancelVoucherDialog,
    ExportLinks,
  },

  data() {
    return {
      cancelDialog: false,
      page: +this.$route.query.page,
      search: '',
    };
  },

  computed: {
    ...mapState(['loading', 'serverPagination', 'isSuperAdmin']),
    ...mapState('loyaltyPanel/redemptions', ['vouchers', 'allGifts']),
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    headers() {
      let headers = [
        {
          text: 'Coupon Claim ID',
          value: 'coupon_claim_id',
        },
        {
          text: this.translations.voucherMobile[this.lang],
          value: 'mobile',
        },
        {
          text: this.translations.giftTitle[this.lang],
          value: 'gift_title',
        },
        {
          text: this.translations.voucherCode[this.lang],
          value: 'voucher',
        },
        {
          text: this.translations[`decrease_${this.storeMode}`][this.lang],
          value: 'decrease_points',
        },
        {
          text: this.translations.couponClaimDate[this.lang],
          value: 'coupon_claim_date',
        },
        {
          text: this.translations.couponIsExpired[this.lang],
          value: 'coupon_claim_is_expired',
        },
        {
          text: this.translations.couponExpirationDate[this.lang],
          value: 'coupon_claim_expiration_date',
        },
        {
          text: this.translations.status[this.lang],
          value: 'status',
        },
        {
          text: 'Redeem ID',
          value: 'redeem_id',
        },
        {
          text: this.translations.redemptionStore[this.lang],
          value: 'redeem_store_name',
        },
        {
          text: 'Action User ID',
          value: 'action_user_id',
        },
      ];
      if (this.isSuperAdmin)
        headers.push({
          text: this.translations.actions[this.lang],
          value: 'actions',
        });
      return headers;
    },

    lang() {
      return this.$route.params.lang;
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/redemptions', ['fetchVouchers', 'fetchAllGifts']),
    ...mapActions(['getPermission']),
    ...mapMutations('loyaltyPanel/redemptions', ['setCancelGiftData']),

    openCancelVoucherDialog(item) {
      this.setCancelGiftData(item);
      this.cancelDialog = true;
    },

    handleSearch() {
      let q = this.query;
      if (this.search?.length) {
        q += `&q=${this.search}`;
      }
      this.fetchAllGifts(q);
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
  },

  mounted() {
    this.fetchAllGifts(this.query);
  },

  watch: {
    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
    },
    query() {
      this.debouncedSearch();
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

    search(val) {
      this.page = 1;
      this.debouncedSearch();
    },
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },
};
</script>
